import { FC } from 'react';
import { CaretLeftIcon, CaretRightIcon } from '@phosphor-icons/react';
import CustomTabsV3 from '../../../shared/CustomTabsV3/CustomTabsV3';
import CustomButton from '../../../shared/CustomButton/CustomButton';
import Typhography from '../../../shared/Typhography/Typhography';
import { AnalysisPeriod, PERIOD_OPTIONS } from './analysis.constants';
import styles from './PeriodSwitch.module.scss';

interface IPeriodSwitchProps {
  period: AnalysisPeriod;
  label: string;
  onChange: (period: AnalysisPeriod) => void;
  onPrev: () => void;
  onNext: () => void;
}

/**
 * Settimana | Mese | Stagione, più le frecce prev/next — stessa forma di
 * navigazione del toolbar di WeekBoard (design M2/M3 §1.5: niente quinto
 * selettore di periodo generico, solo queste tre voci).
 */
const PeriodSwitch: FC<IPeriodSwitchProps> = ({ period, label, onChange, onPrev, onNext }) => (
  <div className={styles.periodSwitch}>
    <CustomTabsV3
      tabs={PERIOD_OPTIONS.map((opt) => ({ label: opt.label, value: opt.value }))}
      value={period}
      onValueChange={(e) => onChange(e.value as AnalysisPeriod)}
      className={styles.periodTabs}
    />

    <div className={styles.nav}>
      <CustomButton
        size="sm"
        color="outline"
        onClick={onPrev}
        icon={<CaretLeftIcon size={16} weight="bold" />}
        iconPosition="left"
        ariaLabel="Periodo precedente"
      />
      <Typhography type="span" size="bold-14" className={styles.label}>
        {label}
      </Typhography>
      <CustomButton
        size="sm"
        color="outline"
        onClick={onNext}
        icon={<CaretRightIcon size={16} weight="bold" />}
        iconPosition="left"
        ariaLabel="Periodo successivo"
      />
    </div>
  </div>
);

export default PeriodSwitch;
